module.exports = __webpack_public_path__ + "static/media/makeAMove_ru.39cc837e.svg";